module.exports = __webpack_public_path__ + "img/floor.54c11749.gif";